<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editSubscription"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card *ngIf="p2SubscriptionKeyno === '0'" ttHeading="h_subscription_new">
            <ng-container *ngTemplateOutlet="editSubscription"></ng-container>
        </tt-card>

        <tt-card *ngIf="p2SubscriptionKeyno !== '0'" ttHeading="h_subscription_edit">
            <ng-container *ngTemplateOutlet="editSubscription"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editSubscription>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="p2_subscription_keyno" [ttModel]="page.p2_subscription_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="word_id_heading" [(ttModel)]="page.word_id_heading" [ttButtons]="headingButtons"></tt-input>
        <tt-input ttLabel="word_id_heading_currentlanguage" [(ttModel)]="page.word_id_heading_currentlanguage"></tt-input>
        <tt-input ttLabel="word_id_description" [(ttModel)]="page.word_id_description" [ttButtons]="descriptionButtons"></tt-input>
        <tt-textarea ttLabel="word_id_description_currentlanguage" [(ttModel)]="page.word_id_description_currentlanguage"></tt-textarea>
        <tt-input-number ttLabel="price_eur" [(ttModel)]="page.price_eur" ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="price_locval" [ttModel]="page.price_locval" ttDecimals="2" ttReadonly></tt-input-number>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto ttText="p2_webpage_subscription" ttGoto="webpagesubscription" [ttGotoParms]="{ argtype: 'p2_subscription_keyno', argvalue: page.p2_subscription_keyno }">
        </tt-button-goto>
    </ng-container>
</ng-template>
